var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01 14.5C7.74 14.5 7.49 14.4 7.3 14.21C7.1 14.01 7.01 13.78 7.01 13.5C7 12.95 7.44 12.51 7.99 12.5C8 12.5 8 12.5 8.01 12.5C8.29 12.5 8.52 12.6 8.72 12.79C8.9 12.98 9 13.22 9 13.49C9 13.76 8.9 14 8.71 14.2C8.52 14.4 8.28 14.5 8.01 14.5ZM7.13 10.84C7.13 10.39 7.23 10 7.42 9.68C7.61 9.35 7.95 8.98 8.42 8.56C8.7 8.31 8.9 8.09 9.03 7.9C9.16 7.71 9.22 7.5 9.22 7.26C9.22 6.97 9.11 6.73 8.9 6.52C8.69 6.32 8.4 6.22 8.05 6.22C7.68 6.22 7.31 6.32 7.09 6.52C6.88 6.72 6.69 6.97 6.69 7.5H5C5 6.49 5.46 5.77 5.97 5.29C6.53 4.78 7.25 4.5 8 4.5C8.59 4.5 9.11 4.62 9.57 4.85C10.03 5.08 10.36 5.4 10.62 5.81C10.88 6.22 11 6.67 11 7.16C11 7.65 10.9 8.06 10.69 8.41C10.48 8.76 10.21 9.12 9.8 9.5C9.48 9.8 9.27 10.06 9.15 10.27C9.03 10.48 8.97 10.76 8.97 11.08V11.5H7.12V10.84H7.13ZM14 8.7C14 5.07 11.35 2.5 8 2.5C4.65 2.5 2 5.07 2 8.7C2 11.04 3.95 14.14 8 17.84C12.05 14.14 14 11.04 14 8.7ZM8 0.5C12.2 0.5 16 3.72 16 8.7C16 12.02 13.33 15.95 8 20.5C2.67 15.95 0 12.02 0 8.7C0 3.72 3.8 0.5 8 0.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8a429fe135a0d837bba38866014312d1.svg";
export { ForwardRef as ReactComponent };